/**
 * Helper
 */
var helper = require('../../helper'),
		dataTables_buttons = [

			{
				extend: 'csv',
				text: 'Export as CSV',
				exportOptions: {
					columns: '.data-export'
				},
				className: 'btn btn-default'
			},
			{
				extend: 'pdf',
				text: 'Export as PDF',
				exportOptions: {
					columns: '.data-export'
				},
				className: 'btn btn-default'
			},
			{
				extend: 'print',
				text: 'Print table',
				exportOptions: {
					columns: '.data-export'
				},
				className: 'btn btn-default'
			},
			{
				extend: 'colvis',
				className: 'btn btn-default'
			}

		];


$(function() {
    var $datatable = $('#datatable-expense-account'),
        columns = [
            { data: 'propertyName', name: 'propertyName', className: 'data-export' },
            { data: 'categoryName', name: 'categoryName', className: 'data-export' },
            { data: 'typeName', name: 'typeName', className: 'data-export' },
            { data: 'purchase_order_number', name: 'purchase_order_number', className: 'data-export' },
            { data: 'invoice_number', name: 'invoice_number', className: 'data-export' },
            { data: 'ticket_id', name: 'ticket_id', className: 'data-export' },
            { data: 'creditor', name: 'creditor', className: 'data-export'},
            { data: 'date', name: 'date', className: 'data-export'},
            { data: 'due_date', name: 'due_date', className: 'data-export'},
            { data: 'amount', name: 'amount', className: 'data-export' },
            { data: 'amount_paid', name: 'amount_paid', className: 'data-export' },
            { data: 'age', name: 'age', orderable: false, searchable: false, className: 'data-export' },
            { data: 'amount_outstanding', name: 'amount_outstanding', searchable: false, className: 'data-export' },
            { data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action" },
        ], $dt;

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
	    "buttons": dataTables_buttons,
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/finance/expense-account",
            "method": 'POST',
	        "data": function ( d ) {
		        d.creditor = $("input[name='creditor']").val();
                d.show_vip = $('input[id=show_vip]').prop("checked");
                d.date_from = $("input[name='date_from']").val();
                d.date_to = $("input[name='date_to']").val();
                d.category_id = $("select[name='category_id']").val();
                d.type_id = $("select[name='type_id']").val();
                d.bank_account_id = $("select[name='bank_account_id']").val();
	        }
        },
	    "stateSave": true,
	    "stateSaveCallback": function(settings,data) {
		    localStorage.setItem( 'DataTables_expense_account_state_' + settings.sInstance, JSON.stringify(data) );
	    },
	    "stateLoadCallback": function(settings) {
		    return JSON.parse( localStorage.getItem( 'DataTables_expense_account_state_' + settings.sInstance ) )
	    },
	    "autoWidth" : false,
        "order": [[ 3, "asc" ]],
        "columns": columns,
        'columnDefs': [
        	{
	            'targets': 9,
	            'className': 'dt-body-center tiny-column',
	            'render': function (data, type, full, meta){
	                return '&pound' + parseFloat(data).toFixed(2);
	            }
            },
	        {
		        'targets': 10,
		        'className': 'dt-body-center tiny-column',
		        'render': function (data, type, full, meta){
			        return '&pound' + parseFloat(data).toFixed(2);
		        }
	        },
	        {
		        'targets': 12,
		        'className': 'dt-body-center tiny-column',
		        'render': function (data, type, full, meta){
			        return '&pound' + parseFloat(data).toFixed(2);
		        }
	        },
        ]
    });

	$('#search-form').on('submit', function(e) {
		$dt.draw();
		e.preventDefault();
	});

});
